module.exports = __webpack_public_path__ + "static/10-8beeb1b27e30da548513e467c3a06087.jpg";